"use strict";
exports.__esModule = true;
exports.AUTOPAY_SETUP = void 0;
exports.AUTOPAY_SETUP = {
    HEADER: 'Rent autopay',
    SUB_HEADER: 'Choose how your 1st payment is charged. Flex will submit your rent after your 1st payment.',
    AUTOPAY_ON: {
        TITLE: 'On',
        CONTENT: 'We’ll automatically process your 1st payment to Flex. This helps ensure your bills are paid on time.'
    },
    AUTOPAY_OFF: {
        TITLE: 'Off',
        CONTENT: 'You’ll use the Flex app to manually make your 1st payment. This gives you more control over timing, but requires your action every month.'
    },
    CTA: 'Save'
};
